export default __webpack_public_path__ + "static/media/logo.ea54d167.svg";